import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {BehaviorSubject, EMPTY, Observable} from 'rxjs';
// import { Socket } from 'ngx-socket-io';
import {User} from '../../models/user';

import {APP_CONFIG} from 'src/app/shared/common/config';
import {Constants} from 'src/app/shared/utils/constants';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<User>;
  private refreshTokenTimeout;
  constructor(
    private http: HttpClient,
    // private socket: Socket,
    private router: Router
  ) {
    this.currentUserSubject = new BehaviorSubject<User>({
      username: localStorage.getItem('USER_LOGGED')
        ? JSON.parse(localStorage.getItem('USER_LOGGED')).username
        : '',
      email: localStorage.getItem('USER_LOGGED')
        ? JSON.parse(localStorage.getItem('USER_LOGGED')).email
        : '',
      password: '',
      token: localStorage.getItem('access_token'),
    });
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(user: any): Observable<any> {
   /* return new Observable<any>((observer) => {
      const res: any = DUMMY_DATA.LOGIN;
      if (res && res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('access_token', res.data.access_token);
        localStorage.setItem('refresh_token', res.data.refresh_token);
        localStorage.setItem(
          'permission',
          JSON.stringify(res.data.permissions)
        );
        this.currentUserSubject.next(res.data);
      }
      observer.next(res);
    });*/
    return this.http
      .post<any>(`${APP_CONFIG.BASE_API_LINK.BASE}/login`, user)
      .pipe(
        map((res) => {
          // login successful if there's a jwt token in the response
          if (res && res.status === Constants.RESPONSE_STATUS.SUCCESS) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('access_token', res.data.access_token);
            localStorage.setItem('refresh_token', res.data.refresh_token);
            localStorage.setItem(
              'permission',
              JSON.stringify(res.data.permissions),
            );
            this.startRefreshTokenTimer();
            this.currentUserSubject.next(res.data);
          }
          return res;
        }),
      );
  }

  register(user: any): Observable<any> {
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.USER}/register`, user)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  activeAccount(token: string): Observable<any> {
    return this.http
      .get(`${APP_CONFIG.BASE_API_LINK.USER}/verify-email`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  reset2FACode(user: any): Observable<any> {
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.USER}/forget-2fa-code`, user)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  resetPassword(user: any): Observable<any> {
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.USER}/forget-password`, user)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  changePassword(user: any, token: string): Observable<any> {
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.USER}/reset-password`, user, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getUserInfo(token: string): any {
    // return this.http.get<any>(this.config.getRootApi("USER_INFO"), {
    //   headers: {
    //     'content-type': 'application/json',
    //     authorization: 'Bearer ' + token
    //   }
    // }).pipe(
    //   retry(1),
    //   // catchError(this.handleError)
    // ).subscribe(response => {
    //   if (response.status == 1000) {
    //     let dataUser = response.user;
    //     let dataWallet = response.wallet;
    //     let setObj = {
    //       user: dataUser,
    //       wallet:dataWallet
    //     }
    //     this.commonService.setUserInfo(setObj);
    //   }
    // });
  }

  private refreshToken(): any {
    const jw_run =  localStorage.getItem('jwt_running');
    if (jw_run !== '0') {
      const refreshToken = localStorage.getItem('refresh_token');
      return this.http.get<any>(`${APP_CONFIG.BASE_API_LINK.BASE}/refresh-token`,
        {
          headers: {
            Authorization: `Bearer ${refreshToken}`,
          },
        })
        .pipe(map((user) => {
          if (user.status === 1000) {
            this.currentUserSubject.next(user?.data);
            localStorage.setItem('access_token', user?.data.access_token);
            localStorage.setItem('refresh_token', user?.data.refresh_token);
            localStorage.setItem('jwt_running', '0'); // indicate refresh token
            this.startRefreshTokenTimer();
          } else {
            this.logout();
          }
        }));
    }
    this.stopRefreshTokenTimer();
    return EMPTY;
  }

  startRefreshTokenTimer(): void {
    // parse json object from base64 encoded jwt token
    const  jwt = localStorage.getItem('access_token');
    try {
      const jwtToken = JSON.parse(atob(jwt.split('.')[1]));

      const nowUtc = new Date(new Date().toUTCString()).getTime();
      const expires = new Date(jwtToken.exp * 1000).toUTCString();
      const deltaTime = new Date(expires).getTime() - nowUtc;
      //console.log(nowUtc, expires, deltaTime)
      const timeout = deltaTime - (60 * 1000);
      // reset timeout
      this.stopRefreshTokenTimer();
      this.refreshTokenTimeout = setTimeout(
        () => this.refreshToken().subscribe(), timeout);
    } catch (e) {
      // console.log('parse refresh token error', e);
      this.logout();
    }
  }

  private stopRefreshTokenTimer(): void {
    clearTimeout(this.refreshTokenTimeout);
  }

  logout(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('permission');
    localStorage.removeItem('USER_LOGGED');
    this.currentUserSubject.next(null);
    this.stopRefreshTokenTimer();
    this.router.navigate(['/login']);
  }
}
